export default "__VITE_ASSET__a1NCkele__"